import React from "react";

const RateBar = React.memo(({ rateDetails, bookingDetails }) => {
  const rateItems = [
    { label: "Total Green Fee", key: "totalGreenFee", isNegative: false },
    { label: "Total Cart Fee", key: "totalCartFee", isNegative: false },
    { label: "Total Caddy Fee", key: "totalCaddyFee", isNegative: false },
    { label: "Discount Amount", key: "totalDiscount", isNegative: true },
    { label: "Total Amount", key: "totalAmount", isNegative: false },
  ];

  const parseWithPrecision = (num, decimals = 2) => {
    const updatedNum = parseFloat(num);
    if (isNaN(updatedNum)) return NaN;
    return parseFloat(updatedNum.toFixed(decimals));
  }


  return (
    <div
      className="book-bar padding-tb20 padding-lr20 margin-b20"
      style={{ color: "#535354", fontSize: "14px", backgroundColor: "#f7f7f7" }}
    >
      <div className="row">
        <div className="col-sm-4">
          {rateItems.map((item) => (
            <div className="row margin-br5" key={item.key}>
              <div className="col-sm-6">
                <strong className="margin-0">{item.label}:</strong>
              </div>
              <div className="col-sm-6">
                <strong className="margin-0">
                  {item.isNegative ? "- " : ""}₹{" "}
                  {parseWithPrecision(rateDetails?.[item.key]) || 0}
                </strong>
              </div>
            </div>
          ))}
        </div>

        <div className="col-sm-4 text-center padding-r50 padding-t20">
          <strong>
            {bookingDetails?.fromDate} To {bookingDetails?.toDate || "-"}
          </strong>
          <br />
          <strong>
            {bookingDetails?.type}: {bookingDetails?.total || 0}
          </strong>
        </div>
      </div>
    </div>
  );
});

export default RateBar;
